import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBG from '../../../images/ComponentImages/categoryScreenBackground.png';
import CourseDescription from '../../../components/courseDescription';
import CourseDescriptionV2 from '../../../components/courseDescriptionV2';
import CourseDescriptionV2Image from '../../../images/CCMRS/CCMRCourseDescriptionV201.png';
import ItemGrid from '../../../components/itemGrid';
import WarningBlock from '../../../components/warningBlock';

export default function Page11({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen titles={['Day 4']} texts={['Recovery Day']} BGImage={CategoryScreenBG} />
			<CourseDescription mt={true} title={'Your schedule'} texts={['1. Cardio', '2. Eat', '3. Vision ']} />
			<CourseDescriptionV2
				mt={true}
				texts={[
					'Incline TreadMill: 45min-1hour',
					'Reason for Cardio',
					"You need to do cardio even if it's just a light workout session, it's great for you. Cardio is important during your recovery days because it increases blood flow throughout your body which helps muscle damage heal quicker. This helps the body build muscle back up quicker and helps push out waste and lactic acid.",
				]}
				bgImage={CourseDescriptionV2Image}
				title={'CARDIO'}
			/>
			<WarningBlock
				texts={[
					'Below is an example of a meal plan. Each Client varies. Each client’s body vaies. For custom food plans contact brugmethod@gmail.com to fit your needs. Thank you.',
				]}
				mt={true}
			/>
			<h1 className='nice-header mt-5 px-3 text-black text-center'>Sustenance</h1>
			<ItemGrid
				mt={true}
				title='Meal One (8:00 - 9:00)'
				rows={[['3 - Whole Eggs', '2 - Turkey Bacon', '½ cup- Rice']]}
			/>
			<ItemGrid
				mt={true}
				title='Meal Two (12:00)'
				rows={[['6oz- Ground Beef', '1 cup-Green Bean', '½ cup- Rice']]}
			/>
			<p className='mt-5 px-3'>Snack</p>
			<p className='mt-3 px-3'>Chocolate Rice Cakes</p>
			<ItemGrid
				mt={true}
				title='Meal Three (16:00-17:00)'
				rows={[['4 - oz - Chicken Breast', '1 cup - Green Bean', '½ cup - Rice']]}
			/>
			<p className='mt-5 px-3'>
				{' '}
				Carbohydrates provide 4 calories per gram, protein provides 4 calories per gram, and fat provides 9
				calories per gram.
			</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
